import { createContext, useContext } from 'react';
import { LoaderStore } from './LoaderStore';

export const LoaderStoreContext = createContext(new LoaderStore());

export const useLoaderStore = () => useContext(LoaderStoreContext);
